import { Placement } from '../Menu/menu.type';

export const getCordinates = (
  triggerHeight: number,
  triggerWidth: number,
  contentHeight: number,
  contentWidth: number,
  placement: Placement,
  x: number,
  y: number,
) => {
  const { innerHeight, innerWidth } = window;

  let top = 0;
  let left = 0;

  switch (placement) {
    case 'top':
      top = -contentHeight;
      left = (triggerWidth - contentWidth) / 2;

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottom':
      top = triggerHeight;
      left = (triggerWidth - contentWidth) / 2;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'topLeft':
      top = -contentHeight;
      left = 0;

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'topRight':
      top = -contentHeight;
      left = -contentWidth + triggerWidth;

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = 0;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottomLeft':
      top = triggerHeight;
      left = 0;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = 0;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    case 'bottomRight':
      top = triggerHeight;
      left = -contentWidth + triggerWidth;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = 0;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top,
        left,
      };

    default:
      top = triggerHeight;
      left = 0;

      if (y + contentHeight > innerHeight) {
        top = -contentHeight;
      }

      if (y - contentHeight < 0) {
        top = triggerHeight;
      }

      if (x + contentWidth > innerWidth) {
        left = -contentWidth + triggerWidth;
      }

      if (x - contentWidth < 0) {
        left = 0;
      }

      return {
        top: triggerHeight,
        left: 0,
      };
  }
};
